import React from "react";
import PropTypes from "prop-types";

import { css } from "glamor";

const styles = {
    title: css({
        color: "#FFF",
        fontSize: "24px",
        fontWeight: "bold",
        marginBottom: "14px",
    }),
};

const Title = ({ children }) => {
    return <div {...styles.title}>{children}</div>;
};

Title.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node),
    ]),
};

export default Title;
